import axios from "axios";

const backendUrl = (process.env.REACT_APP_BACKEND_URL || "").trim().replace(/\/+$/, "");

export const BACKEND_CONFIGURED = Boolean(backendUrl);
export const API = BACKEND_CONFIGURED ? `${backendUrl}/api` : "";
export const api = axios.create({ baseURL: API || undefined, timeout: 15000, withCredentials: true });

api.interceptors.request.use((config) => {
  if (BACKEND_CONFIGURED) return config;
  const error = new Error("BACKEND_NOT_CONFIGURED");
  error.code = "BACKEND_NOT_CONFIGURED";
  return Promise.reject(error);
});

export function isBackendNotConfigured(error) {
  return error?.code === "BACKEND_NOT_CONFIGURED" || error?.message === "BACKEND_NOT_CONFIGURED";
}

export function fmtTime(value) {
  if (!value) return "—";
  try {
    return new Date(value).toLocaleString();
  } catch {
    return value;
  }
}

export function fmtPercent(value) {
  return value === null || value === undefined ? "—" : `${value}%`;
}
